<div class="inline-label-control {{classess}}" [class.filled]="control?.value" [class.disabled]="disabled"
  [class.secondary]="lightMode" [class.primary]="!lightMode" [class.sm]="sm">
  @if (label) {
  <label (click)="!control.disabled && dropdown1.show()">{{label}}</label>
  }

  <p-dropdown [placeholder]="placeholder" [showClear]="showClear"
    (onClear)="showClear && triggerAfterClearAction($event)" (onClick)="triggerAction($event)" #dropdown1
    [formControl]="control" [options]="immutableOptions" optionLabel="label" optionValue="value"
    optionDisabled="disabled" [filter]="optionsSearchEnabled" [autofocusFilter]="false" [resetFilterOnHide]="true" filterBy="label"
    [loading]="loading">
    <ng-template let-option pTemplate="item">
      <div class="d-flex align-items-center w-100 h-100" [class.multi-lines]="optionMultiLines">
        @if (additionalActionIconName === 'add-circle' && option.label == additionalActionLabel) {
        <img class="inner-option-icon mr-8-px" src="./../../../../../assets/images/icons/add_circle.svg" alt="add-icon">
        }
        <span class="option-label"
          [class.overflow-ellipsis]="optionsOverflowEllipsis || !optionMultiLines">{{ option.label }}
          @if(option.count){
          <span class="count">
            ({{option.count}})
          </span>
          }</span>
      </div>
    </ng-template>


  </p-dropdown>
</div>
